<div class="st-fatal-header">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    <div class="st-fatal-header-title">{{ title }}</div>
</div>
<div class="st-fatal-body">{{ detailed }}</div>
<div class="st-fatal-footer">
    <button
        mat-button
        class="st-fatal-button-reset"
        cdkInitialFocus
        (click)="onRestartClick()">
        {{ restart }}
    </button>
</div>
